import React from 'react';
// import { useHistory } from 'react-router-dom';
import { isPlatform } from '@ionic/react';

import { Plugins } from '@capacitor/core';
import 'capacitor-jitsi-meet';

// import { iframeReplace } from 'core/iframe/IframeLink';

const { Jitsi } = Plugins;

export const Meet = props => {
    // const history = useHistory();
    const [jitsi, setJitsi] = React.useState(false);

    const href = 'https://meet.100os.events';
    const room = 'abc';

    const initConference = React.useCallback(async () => {
        if (isPlatform('cordova')) {
            const result = await Jitsi.joinConference({
                roomName: room,
                url: href,
                startWithAudioMuted: true,
                startWithVideoMuted: false,
            });
            return setJitsi(result);
        }
        if (!isPlatform('mobileweb')) {
            console.log('Redirect to the meet url', `${href}/${room}`);
            // window.location.href = `${href}/${room}`;
            return false;
        }
        console.error('Jitsi not supported!');
        // history.goBack();
        return false;
    }, [href, room]);

    const onJoined = () => {
        console.log('Meet: onConferenceJoined');
    };
    const onLeft = () => {
        console.log('Meet: onConferenceLeft');
    };

    React.useEffect(() => {
        initConference();
        window.addEventListener('onConferenceJoined', onJoined);
        window.addEventListener('onConferenceLeft', onLeft);
        return () => {
            window.removeEventListener('onConferenceJoined', onJoined);
            window.removeEventListener('onConferenceLeft', onLeft);
        };
    }, [initConference]);

    return jitsi;
};
export default Meet;
